import React from "react";
import { connect } from "react-redux";
import SparkleCard from "../../components/SparkleCard";
import ReferralsCard from "../../components/Dashboard/ReferralsCard";
import PageHeader from "../../components/PageHeader";
import LogoiCON from "../../assets/images/logo.png";
import { sparkleCardData } from "../../Data/DashbordData";
import axios from "axios";

class Dashbord extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardData: [],
      loading: true,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadDataCard();
    this.setState({ cardData: [...sparkleCardData] });
  }

  async loadDataCard() {
    try {
      const allCardData = await Promise.all(
        sparkleCardData.map(async (data) => {
          try {
            const response = await axios.get(data.apiUrl);
            const result = response.data;
            const count = Array.isArray(result) ? result.length : 0;
            const updatedData = Array.isArray(result)
              ? result.map(item => item.someMetric || Math.floor(Math.random() * 10) + 1)
              : [];
            return {
              ...data,
              money: `$${count * 1000}`,
              sparklineData: {
                ...data.sparklineData,
                data: updatedData,
              },
              perText: `${count} new items this period`,
            };
          } catch (error) {
            console.error('Error fetching data:', error);
            return {
              ...data,
              money: "Error",
              sparklineData: {
                ...data.sparklineData,
                data: [],
              },
              perText: "Data load failed",
            };
          }
        })
      );
      this.setState({ cardData: allCardData, loading: false });
    } catch (error) {
      console.error('Error loading data card:', error);
      this.setState({ loading: false });
    }
  }

  render() {
    const { loadingPage } = this.props;
    const { cardData, loading } = this.state;

    if (loadingPage || loading) {
      return (
        <div className="page-loader-wrapper">
          <div className="loader">
            <div className="m-t-30">
              <img src={LogoiCON} width="48" height="48" alt="MarwadiSamaj" />
            </div>
            <p>Please wait...</p>
          </div>
        </div>
      );
    }

    return (
      <div onClick={() => document.body.classList.remove("offcanvas-active")}>
        <div className="container-fluid">
          <PageHeader HeaderText="Dashboard" Breadcrumb={[{ name: "Dashboard" }]} />
          <div className="row clearfix">
            {cardData.map((data, i) => (
              <SparkleCard
                key={i}
                Heading={data.heading}
                PerText={data.perText}
                apiUrl={data.apiUrl}
                isRandomUpdate={true}
                chartColor={data.sparklineData.areaStyle.color}
                ContainerClass="col-lg-3 col-md-6 col-sm-6"
                index={i} // Ensure index is passed if needed
              />
            ))}
          </div>
          <div className="row clearfix">
            <div className="col-lg-3 col-md-6">
              <ReferralsCard />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ loadingPage: state.pageLoading }))(Dashbord);
